// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetAgenciesRequest,
  TGetAgenciesModel,
  IMappers,
  TGetAgenciesResponse,
  IGetAgenciesResponse,
  IGetAgenciesResponseError,
} from './types';

export const defaultConfig: TGetAgenciesModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'agent-catalog-search',
  pathApi: '/v1/get-agencies/',
} as TGetAgenciesModel;

export function createGetAgenciesModel(parameters: IGetAgenciesRequest): TGetAgenciesModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetAgenciesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetAgenciesRequest;
}

export async function fetchGetAgencies<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetAgenciesOptions<TResponse200, TResponse400>): Promise<TGetAgenciesResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetAgenciesModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetAgenciesResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetAgenciesResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetAgenciesResponse;
}
